import { render } from "./GestioneGeneral.vue?vue&type=template&id=4dfe5848&scoped=true"
import script from "./GestioneGeneral.vue?vue&type=script&lang=js"
export * from "./GestioneGeneral.vue?vue&type=script&lang=js"

import "./GestioneGeneral.vue?vue&type=style&index=0&id=4dfe5848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfe5848"]])

export default __exports__